import React, { PureComponent } from 'react';
import { Card, CardBody, Col } from 'reactstrap';

import CheckIcon from 'mdi-react/CheckIcon';
import PropTypes from 'prop-types';
import uuid from 'uuid';
import { Link } from 'react-router-dom';

class CheckBox extends PureComponent {
  static propTypes = {
    checked: PropTypes.bool,
  };

  render () {
    return (
      <label
        className='checkbox-btn profile__current-task-checkbox'>
        <input className='checkbox-btn__checkbox' type='checkbox' checked={this.props.checked} />
        <span className='checkbox-btn__checkbox-custom'>
          <CheckIcon />
        </span>
      </label>
    )
  }
}

export default function (props) {
  return (
    <Col md={12}>
      <Card>
        <CardBody>
          <div style={{ flex: 2, flexDirection: 'row' }}>
            <span>
              <img
                className='report_img'
                alt={props.img}
                src={`${process.env.PUBLIC_URL}/img/${props.img}`} />
            </span>
            <span style={{ fontSize: 24, marginLeft: 20 }}>{props.title}</span>
          </div>
          {
            props.data ?
              props.data.map(item => {
                return <div key={uuid()} className='flex_display'>
                  <CheckBox />
                  <p><span style={{ marginLeft: 30 }}>{item.body} <Link to={item.url}>{item.linkText}</Link></span></p>
                </div>
              })
              : null
          }
        </CardBody>
      </Card>
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/recommendations/components/recommendationItem.js